module.exports = __webpack_public_path__ + "media/images/icons/twotone/bug-e920e00147907cfcdc7487ea7ebf9458.svg";